
import { useQuery } from '@tanstack/react-query';
import { fetchResources, fetchFilterOptions, fetchSingleResource } from '@/services/resourceService';

export type { Resource, ResourceFilters } from '@/services/resourceService';

export function useResources(
  searchQuery?: string,
  filters?: import('@/services/resourceService').ResourceFilters,
  sortBy: string = 'relevance'
) {
  return useQuery({
    queryKey: ['resources', searchQuery, filters, sortBy],
    queryFn: () => fetchResources(searchQuery, filters, sortBy),
    staleTime: 2 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    refetchInterval: 2 * 60 * 1000,
    refetchOnWindowFocus: true,
    refetchOnMount: true,
  });
}

export function useResourceFilters() {
  return useQuery({
    queryKey: ['resource-filters'],
    queryFn: fetchFilterOptions,
    staleTime: 5 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
  });
}

export function useResource(resourceName: string) {
  return useQuery({
    queryKey: ['resource', resourceName],
    queryFn: () => fetchSingleResource(resourceName),
    staleTime: 5 * 60 * 1000,
    enabled: !!resourceName,
  });
}
